import DreadNought from "./dreadnought.js";
import ShipFighter from "./ship-fighter.js";

export { DreadNought, ShipFighter };
